import React, {Component} from 'react';
import {Button, Card, Cascader, Col, Form, Input, InputNumber, Row, Select} from 'antd';
import {Link} from 'react-router';
import {connect} from 'react-redux';

import chinaAddressOptions from '@comm/cascader-address-pca-options';
import UploadSinglePic from '@comm/upload/UploadSinglePic';
import {BackBtn} from '@comm/BackBtn';
import {queryAccountList} from '@api/core/user';
import {queryOrgList} from "@api/core/org";

const { Option } = Select;
const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orgList: [],
      accountList: [],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getOrgList();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data.companyUuid !== this.props.data.companyUuid) {
      this.getAccountList(nextProps.data.companyUuid);
    }
  }

  getOrgList = () => {
    queryOrgList({
        type: 1,
        uuid: 'F58BDBC0066B4FB0A8E54BCAF77DA727',
      })
      .then(res => {
        if (res.statusCode === 200) {
          this.setState({
            orgList: res.data,
          });
        }
      });
  };

  getAccountList = orgUuid => {
    queryAccountList({ orgUuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          accountList: res.data,
        });
      }
    });
  };

  handleComChange = (e, option) => {
    this.getAccountList(e);
    this.props.form.setFieldsValue({ name: option.props.children });
  };

  handlleAdminChange = (e, option) => {
    this.props.form.setFieldsValue({ admin: option.props.children });
  };

  handlleHatchChange = (e, option) => {
    this.props.form.setFieldsValue({ hatchManager: option.props.children });
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit, data } = this.props;
    const user = this.props.form.getFieldsValue();
    if (data && data.uuid) {
      user.uuid = data.uuid;
    }
    this.props.form.validateFields((err, values) => {
      if (!err) {
        handSubmit(user);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { orgList, accountList } = this.state;
    const { data } = this.props;
    const ItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };

    const ItemLayout2 = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
    };
    getFieldDecorator('name', { initialValue: data.name });
    getFieldDecorator('hatchManager', { initialValue: data.hatchManager });
    getFieldDecorator('admin', { initialValue: data.admin });

    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: 15 }}>
          <BackBtn />
          <Button icon="save" style={{ marginRight: 10 }} htmlType="submit">
            保存
          </Button>
        </div>
        <Card title="基本信息" className="mb16">
          <Row>
            <Col span={10}>
              <FormItem label="孵化器名称" {...ItemLayout}>
                {getFieldDecorator('companyUuid', {
                  rules: [{ required: true, message: '请输入孵化器名称!' }],
                  initialValue: data ? data.companyUuid : '',
                })(
                  <Select onChange={this.handleComChange}>
                    {orgList.map(item => (
                      <Option key={item.uuid}>{item.name}</Option>
                    ))}
                  </Select>,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="孵化器简称" {...ItemLayout}>
                {getFieldDecorator('sort', {
                  rules: [{ required: true, message: '请输入孵化器简称!' }],
                  initialValue: data ? data.sort : '',
                })(<Input placeholder="孵化器简称" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="所在地区" {...ItemLayout}>
                {getFieldDecorator('region', {
                  initialValue: data ? data.region : [],
                })(
                  <Cascader
                    options={chinaAddressOptions}
                    onChange={this.chaneRegion}
                    changeOnSelect
                    placeholder="请选择地址"
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="详细地址" {...ItemLayout}>
                {getFieldDecorator('address', {
                  initialValue: data ? data.address : '',
                })(<Input placeholder="详细地址" />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="请上传logo" {...ItemLayout}>
                {getFieldDecorator('logo', {
                  rules: [{ required: true, message: '请上传logo' }],
                  initialValue: data ? data.logo : '',
                })(<UploadSinglePic type="ghost" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="孵化器简介" {...ItemLayout2}>
                {getFieldDecorator('remark', {
                  initialValue: data.remark,
                })(
                  <Input.TextArea
                    placeholder="孵化器简介"
                    type="textarea"
                    autosize={{ minRows: 3, maxRows: 9 }}
                    maxLength={1000}
                  />,
                )}
                <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
              </FormItem>
            </Col>
          </Row>
        </Card>
        {data.uuid ? (
          <Card title="业务信息">
            <Row>
              <Col span={20}>
                <FormItem label="工位数" {...ItemLayout2}>
                  <Row>
                    <Col span={1}> 总计:</Col>
                    <Col span={3}>
                      {getFieldDecorator('stationSum', {
                        initialValue: data ? data.stationSum : '',
                      })(<InputNumber min={0} />)}
                    </Col>
                    <Col span={4}>
                      <span style={{ padding: '0 10px' }}>
                        已用:<span>{data.stationUsedSum || '暂无'}</span>
                      </span>
                    </Col>
                    <Col span={4}>
                      <Link to={`/incubator/seat/${data.uuid}`}>
                        <Button type="primary">编辑</Button>
                      </Link>
                    </Col>
                  </Row>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span={20}>
                <FormItem label="地址数" {...ItemLayout2}>
                  <Row>
                    <Col span={1}> 总计:</Col>
                    <Col span={3}>
                      {getFieldDecorator('addressSum', {
                        initialValue: data ? data.addressSum : '',
                      })(<InputNumber min={0} />)}
                    </Col>
                    <Col span={4}>
                      <span style={{ padding: '0 10px' }}>
                        已用:<span>{data.addressUsedSum || '暂无'}</span>
                      </span>
                    </Col>
                    <Col span={4}>
                      <Link to={`/incubator/address/${data.uuid}`}>
                        <Button type="primary">编辑</Button>
                      </Link>
                    </Col>
                  </Row>
                </FormItem>
              </Col>
            </Row>
          </Card>
        ) : null}

        <Card title="人员信息">
          <Row>
            <Col span={10}>
              <FormItem label="园长" {...ItemLayout}>
                {getFieldDecorator('hatchManagerUuid', {
                  initialValue: data ? data.hatchManagerUuid : '',
                })(
                  <Select onChange={this.handlleHatchChange}>
                    {accountList.map(item => (
                      <Option key={item.uuid}>{item.name}</Option>
                    ))}
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="行政" {...ItemLayout}>
                {getFieldDecorator('adminUuid', {
                  initialValue: data ? data.adminUuid : '',
                })(
                  <Select onChange={this.handlleAdminChange}>
                    {accountList.map(item => (
                      <Option key={item.uuid}>{item.name}</Option>
                    ))}
                  </Select>,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="行政人员联系方式" {...ItemLayout}>
                {getFieldDecorator('adminContact', {
                  initialValue: data ? data.adminContact : '',
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
        </Card>
      </Form>
    );
  }
}

export default connect(state => ({ organization: state.organization }))(
  Form.create({ wrappedComponentRef: true })(BaseForm),
);



// WEBPACK FOOTER //
// ./src/components/incubator/base/FormEdit.js